import axiosClient from './axiosClient';

const rpcV2Controller = {
  sendRpcRequest(token, deviceId, device, state) {
    const url = `/api/rpc/oneway/${deviceId}`;
    const payload = {
      method: device,
      params: state,
      persistent: false,
      timeout: 500,
    };
    return axiosClient.post(url, payload, {
      headers: {
        'X-Authorization': 'Bearer ' + token,
      },
    });
  },
};

export default rpcV2Controller;
